import React from 'react';

import { Helpers } from '../../core/src/helpers';
import CartButton from '../../shared/components/cart-button';
import { Carousel } from '../../shared/components/carousel';
import NavArrow from '../../shared/components/nav-arrow';
import XSellProduct from './origin-xsell-product';
import { getTabsModalCategories } from '../xsell-actions';

import '../css/tabs-xsell-modal.less';

class TabsXSellModal extends React.Component {

    constructor(props) {
        super(props);

        let { xSellProductList, product } = this.props;
        let categories = getTabsModalCategories(xSellProductList, product);
        this.state = {
            activeTab: 'Most Popular',
            skusAdded: [],
            categories
        }
    }

    closeModal = () => {
    	this.props.closeXSellModal();
    }

    handleAddandRemove = (action, sku) => {
        if (action === 'add') {
            this.setState({
                skusAdded: [...this.state.skusAdded, sku]
            })
        } else if (action === 'remove') {
            this.setState({
                skusAdded: this.state.skusAdded.filter((prodSku) => prodSku !== sku)
            })
        }
    }

    changeTab = (tabName) => {
        this.setState({ activeTab: tabName })
    }

    controls(type) {
        if (type === 'category') {
            return {
                slidesToShow: 6,
                slidesToScroll: 6,
                renderCenterLeftControls : NavArrow.PrevArrow,
                renderCenterRightControls: NavArrow.NextArrow,
                renderBottomCenterControls: () => <div></div>
            }
        } else if (type === 'product') {
            return {
                slidesToShow: 3,
                slidesToScroll: 3,
                renderCenterLeftControls : NavArrow.PrevArrow,
                renderCenterRightControls: NavArrow.NextArrow,
            }
        }
    }

    render() {
        const { product, cartItems, getProductClickMetrics, ctaMetrics } = this.props;
        const { categories, activeTab, skusAdded } = this.state;
        const { name, isSmb, sku } = product;
        const isProductPC = Helpers.isProductPC(product);
        const catSettings = {
            ...this.controls('category'),
        };
        const prodSettings = {
            ...this.controls('product'),
        };

        let title;
        let date = new Date('12/1/2020');
        if (new Date() > date && isProductPC) {
            title = 'Get <b>15%</b> off select accessories and <b>10%</b> off select monitors with purchase of PC.'
        } else if (isProductPC) {
            title = 'Get <b>15%</b> off select accessories and monitors with purchase of PC.'
        } else {
            title = 'Frequently bought together';
        }
        
        const content = Object.keys(categories).length > 0 && categories.constructor === Object ?
        <div>
            <div className="modal-header-wrapper">
                <span className="header-name">{name}</span> has been added to cart.
            </div>
                <div dangerouslySetInnerHTML={Helpers.createMarkup(title)} className={`sub-header${isSmb === 'Yes' ? ' business' : ' consumer'}${isProductPC ? ' pc' : ''} bundle-test-orig`}></div>
            <div className='xsell-category-list'>
                <Carousel className='xsell-category-carousel' {...catSettings} ref={carousel => this.carousel = carousel}>
                    {(Object.keys(categories) || []).map((category, i) => {
                        return (
                        <div className={category === activeTab ? 'active-tab tab' : 'tab'} key={i} onClick={() => this.changeTab(category)}>
                            <div className={`hp-icon default ${categories[category].displayName.toLowerCase().replace(/ |, /g, '-').replace(/\&/g, 'and')}`}></div>
                            <span>{category}</span>
                        </div>
                        )
                    })}
                </Carousel>
            </div>
            <div className="xsell-category-products">
                <Carousel className='xsell-category-carousel' {...prodSettings} ref={carousel => this.carousel = carousel}>
                    {((categories[activeTab] || {}).products || []).slice(0, 6).map((prod, i) => {
                        return <XSellProduct
                                    key={i}
                                    baseProductSku={sku} 
                                    product={prod}
                                    xsellTemplate={'tabs'}
                                    handleAddandRemove={this.handleAddandRemove}
                                    added={skusAdded.indexOf(prod.sku) > -1}
                                    cartItems={cartItems}
                                    productClickMetrics={typeof getProductClickMetrics === 'function' ? getProductClickMetrics({product: prod, position: i+1 }) : null}
                                    ctaMetrics={ctaMetrics}
                                />
                    })}
                </Carousel>
            </div>
            <CartButton
                buttonText={'Continue to cart'}
                className={'tabs-xsell-modal'}
            />
        </div> : null;
        return content;
    }
};

export default TabsXSellModal;
